type IconProps = React.HTMLAttributes<SVGElement>;

export const IllustrationOpenSpace = (props: IconProps) => {
	return (
		<svg width="342" height="263" viewBox="0 0 342 263" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M45.7891 230.5V110.858L291.006 14.832V134.096L45.7891 230.5Z" fill="#F6F7F8" />
			<path d="M291.005 136.949V15.2109L136.98 76.0775L291.005 136.949Z" fill="black" stroke="black" />
			<path
				d="M59.0232 112.822C60.6658 112.177 62.1886 112.079 63.4503 112.437L63.6993 112.515L70.7516 115.319L58.7869 157.93L52.3446 154.515C51.6245 153.668 51.1846 152.518 51.1201 151.125L51.121 123.425C51.3286 119.195 54.7607 114.495 59.0232 112.822Z"
				fill="black"
				stroke="black"
			/>
			<rect
				x="0.469948"
				y="0.329269"
				width="17.1964"
				height="43.9692"
				rx="8.59821"
				transform="matrix(0.939896 -0.341462 3.50108e-08 1 56.5771 117.484)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path
				d="M59.0232 164.976C60.6658 164.332 62.1886 164.234 63.4503 164.591L63.6993 164.669L70.7516 167.473L58.7869 210.084L52.3446 206.669C51.6245 205.822 51.1846 204.673 51.1201 203.279L51.121 175.579C51.3286 171.35 54.7607 166.65 59.0232 164.976Z"
				fill="black"
				stroke="black"
			/>
			<rect
				x="0.469948"
				y="0.329269"
				width="17.1964"
				height="43.9692"
				rx="8.59821"
				transform="matrix(0.939896 -0.341462 3.50108e-08 1 56.5771 169.638)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path
				d="M148.191 173.703L82.9518 147.594L82.9518 97.3097L87.2133 95.7042L148.191 119.232L148.191 173.703Z"
				fill="#BDFF9C"
				stroke="black"
			/>
			<rect
				x="-2.98023e-08"
				y="0.365395"
				width="65.812"
				height="94.0338"
				transform="matrix(0.930853 0.365395 -0.930853 0.365395 175.088 60.9165)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<rect
				x="-2.98023e-08"
				y="0.365395"
				width="66.1567"
				height="19.3686"
				transform="matrix(0.930853 0.365395 -0.930853 0.365395 143.602 73.4438)"
				fill="#BDFF9C"
				stroke="black"
			/>
			<rect
				x="0.465426"
				y="0.317303"
				width="94.4433"
				height="53.8119"
				transform="matrix(0.930853 -0.365395 3.24028e-08 1 147.702 119.602)"
				fill="#F6F7F8"
				stroke="black"
			/>
			<rect
				x="0.465426"
				y="0.317303"
				width="18.2953"
				height="15.7247"
				transform="matrix(0.930853 -0.365395 3.24028e-08 1 186.415 104.645)"
				fill="#BDFF9C"
				stroke="black"
			/>
			<path d="M33 116.372L309 8.03167" stroke="black" />
			<path d="M33 235.836L309 127.496" stroke="black" />
			<path d="M45.9122 99.206L45.9121 247.202" stroke="black" />
			<path d="M296.088 1.00195L296.088 146.011" stroke="black" />
			<path d="M78.1862 98.7656V210.109M78.1862 210.109L88.0224 213.917M78.1862 210.109L46.2188 222.484" stroke="black" />
			<path
				d="M216.495 128.999L206.287 126.5C206.15 126.467 206.09 126.305 206.172 126.19L283.776 17.8562L296 13.0869L216.495 128.999Z"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path d="M33 116.369L309 8.02875" stroke="black" />
			<path d="M33 235.834L309 127.494" stroke="black" />
			<path d="M46 111.462L45.9121 247.199" stroke="black" />
			<path d="M296.088 1L296.088 146.009" stroke="black" />
			<path
				d="M296.566 131.646L216.305 249.441C216.194 249.603 215.939 249.525 215.939 249.328V129L296 13.5859L296.566 131.646Z"
				fill="#F6F7F8"
				stroke="black"
			/>
			<path d="M206 126.931L205.375 246.55L215.384 249.226V129.035L206 126.931Z" fill="black" stroke="black" />
			<path
				d="M216.814 249.578L216.5 249.431L296.565 132.025C299.762 134.937 300.351 139.749 297.95 143.346L229.387 246.08C226.639 250.197 221.293 251.685 216.814 249.578Z"
				fill="#BDFF9C"
				stroke="black"
			/>
			<rect
				x="-2.98023e-08"
				y="0.443461"
				width="18.706"
				height="18.706"
				rx="4.5"
				transform="matrix(0.896294 0.443461 -0.896294 0.443461 20.0596 188.247)"
				fill="#FFCBE2"
				stroke="black"
			/>
			<path
				d="M38.9598 200.268C40.8733 199.243 44.1086 199.189 46.1932 200.13C50.5212 202.082 54.9291 203.958 59.408 205.758C96.789 220.776 139.227 230.486 181.956 234.706C182.336 234.744 182.705 234.56 182.905 234.234L184.223 232.086C184.822 231.108 186.213 230.908 187.198 231.659L199.925 241.354C201.205 242.33 200.983 244.205 199.527 244.708L175.841 252.888C174.047 253.508 172.303 251.528 173.264 249.962L174.246 248.358C174.63 247.733 174.232 246.921 173.502 246.839C128.54 241.808 84.0683 231.291 44.6561 215.457C39.5168 213.392 34.4641 211.237 29.5096 208.993C27.4601 208.064 27.3523 206.49 29.2371 205.479L38.9598 200.268Z"
				fill="#F6F7F8"
			/>
			<path
				d="M38.9598 200.268L39.196 200.709L39.196 200.709L38.9598 200.268ZM46.1932 200.13L45.9876 200.585V200.585L46.1932 200.13ZM59.408 205.758L59.2216 206.222L59.2216 206.222L59.408 205.758ZM184.223 232.086L184.649 232.347L184.649 232.347L184.223 232.086ZM187.198 231.659L187.501 231.261L187.501 231.261L187.198 231.659ZM199.925 241.354L199.622 241.752L199.622 241.752L199.925 241.354ZM199.527 244.708L199.364 244.235L199.527 244.708ZM175.841 252.888L176.004 253.361L176.004 253.361L175.841 252.888ZM173.264 249.962L173.69 250.223L173.69 250.223L173.264 249.962ZM44.6561 215.457L44.4697 215.921L44.6561 215.457ZM29.5096 208.993L29.3033 209.448L29.3033 209.448L29.5096 208.993ZM29.2371 205.479L29.001 205.039L29.0009 205.039L29.2371 205.479ZM173.502 246.839L173.447 247.336L173.502 246.839ZM181.956 234.706L181.906 235.204L181.956 234.706ZM182.905 234.234L183.331 234.496L182.905 234.234ZM38.9598 200.268L39.196 200.709C40.0626 200.245 41.2655 199.985 42.5215 199.962C43.7757 199.939 45.0285 200.153 45.9876 200.585L46.1932 200.13L46.3988 199.674C45.2733 199.166 43.8662 198.937 42.5032 198.962C41.1421 198.987 39.7706 199.266 38.7236 199.828L38.9598 200.268ZM46.1932 200.13L45.9876 200.585C50.3221 202.541 54.7365 204.42 59.2216 206.222L59.408 205.758L59.5944 205.294C55.1217 203.497 50.7202 201.624 46.3988 199.674L46.1932 200.13ZM59.408 205.758L59.2216 206.222C96.6526 221.26 139.137 230.979 181.906 235.204L181.956 234.706L182.005 234.209C139.316 229.992 96.9254 220.292 59.5944 205.294L59.408 205.758ZM182.905 234.234L183.331 234.496L184.649 232.347L184.223 232.086L183.796 231.824L182.479 233.973L182.905 234.234ZM184.223 232.086L184.649 232.347C185.072 231.657 186.111 231.459 186.895 232.057L187.198 231.659L187.501 231.261C186.314 230.357 184.572 230.559 183.796 231.824L184.223 232.086ZM187.198 231.659L186.895 232.057L199.622 241.752L199.925 241.354L200.228 240.957L187.501 231.261L187.198 231.659ZM199.925 241.354L199.622 241.752C200.631 242.521 200.388 243.882 199.364 244.235L199.527 244.708L199.69 245.18C201.578 244.529 201.779 242.138 200.228 240.957L199.925 241.354ZM199.527 244.708L199.364 244.235L175.677 252.416L175.841 252.888L176.004 253.361L199.69 245.18L199.527 244.708ZM175.841 252.888L175.678 252.416C175.001 252.649 174.322 252.4 173.895 251.914C173.468 251.43 173.348 250.781 173.69 250.223L173.264 249.962L172.837 249.7C172.219 250.708 172.491 251.833 173.144 252.575C173.797 253.316 174.886 253.747 176.004 253.361L175.841 252.888ZM173.264 249.962L173.69 250.223L174.673 248.619L174.246 248.358L173.82 248.097L172.837 249.7L173.264 249.962ZM173.502 246.839L173.558 246.342C128.634 241.316 84.2071 230.808 44.8425 214.993L44.6561 215.457L44.4697 215.921C83.9296 231.774 128.446 242.301 173.447 247.336L173.502 246.839ZM44.6561 215.457L44.8425 214.993C39.7097 212.931 34.6637 210.779 29.7159 208.538L29.5096 208.993L29.3033 209.448C34.2646 211.696 39.3239 213.853 44.4697 215.921L44.6561 215.457ZM29.5096 208.993L29.7159 208.538C28.7555 208.102 28.4238 207.594 28.3966 207.23C28.3707 206.883 28.605 206.385 29.4734 205.92L29.2371 205.479L29.0009 205.039C27.9844 205.584 27.3302 206.378 27.3994 207.304C27.4672 208.212 28.2142 208.955 29.3033 209.448L29.5096 208.993ZM29.2371 205.479L29.4733 205.92L39.196 200.709L38.9598 200.268L38.7236 199.828L29.001 205.039L29.2371 205.479ZM174.246 248.358L174.673 248.619C175.248 247.681 174.65 246.465 173.558 246.342L173.502 246.839L173.447 247.336C173.813 247.377 174.012 247.785 173.82 248.097L174.246 248.358ZM181.956 234.706L181.906 235.204C182.478 235.26 183.031 234.985 183.331 234.496L182.905 234.234L182.479 233.973C182.379 234.136 182.194 234.227 182.005 234.209L181.956 234.706Z"
				fill="black"
			/>
		</svg>
	);
};
